module.exports = __webpack_public_path__ + "img/service-211.30cc20bf.png";